module.exports = __webpack_public_path__ + "img/840.c15ac440.jpg";